import de from '../../locale/de.json';
import en from '../../locale/en.json';
import es from '../../locale/es.json';
import esMX from '../../locale/es-MX.json';
import fr from '../../locale/fr.json';
import ja from '../../locale/ja.json';
import ko from '../../locale/ko.json';
import pt from '../../locale/pt.json';
import ptBR from '../../locale/pt-BR.json';
import ru from '../../locale/ru.json';
import tr from '../../locale/tr.json';
import zhCN from '../../locale/zh-CN.json';
import zhTW from '../../locale/zh-TW.json';

export const templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g;

export const localeMap = {
    en,
    ja,
    de,
    fr,
    es,
    'es-mx': esMX,
    pt,
    'pt-br': ptBR,
    ko,
    ru,
    tr,
    'zh-cn': zhCN,
    'zh-tw': zhTW,
    keys: Object.keys(en).reduce((accum, current) => ({
        ...accum,
        [current]: current,
    }), {}),
};

